// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"361":"a32db14ad33065a7be42","808":"82eb354215f1c7afacb9","983":"6635bcd3297311b04472"}[chunkId] + ".js";
};